import Quill from 'quill'

const EmbedBlot = Quill.import('blots/embed')

export class UserMentionBlot extends EmbedBlot {
  static create (data) {
    const node = super.create()
    node.setAttribute('data-user-id', data.userId)
    node.setAttribute('title', data.title)
    node.setAttribute('contenteditable', 'false')
    node.textContent = data.name
    return node
  }

  static remove () {
    super.remove()
  }

  static value (node) {
    return {
      userId: node.getAttribute('data-user-id'),
      title: node.getAttribute('title'),
      name: node.textContent
    }
  }
}

UserMentionBlot.blotName = 'userMention'
UserMentionBlot.tagName = 'strong'
UserMentionBlot.className = 'user-mention'
